import React from 'react'
import { FormControl, FormGroup, Row, Col } from 'react-bootstrap'

import adminStyles from './styles/admin.scss'

export default class TranslationInput extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.translation != nextProps.translation ||
      this.props.translationInEnglish != nextProps.translationInEnglish
    )
  }

  render() {
    return (
      <FormGroup
        controlId={this.props.translationKey + ''}
        bsSize="sm"
        className={adminStyles.smallFormGroup}
      >
        <Row style={{ marginBottom: 15 }}>
          <Col xs={12}>
            <small style={{ fontWeight: 'normal', fontSize: 11, float: 'right' }}>
              {this.props.label}
            </small>

            <small style={{ color: 'grey' }}>
              {this.props.translationInEnglish && <span>{this.props.translationInEnglish}</span>}
            </small>
          </Col>

          <Col xs={12}>
            <FormControl
              name={this.props.translationKey}
              type="text"
              onChange={this.props.onChange}
              value={this.props.translation || ''}
            />
          </Col>
        </Row>
      </FormGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TranslationInput.js